<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>

  <div>
    <mat-form-field class="full-width">
      <mat-select placeholder="Select destination" [(ngModel)]="destinationWalletId" name="destinationWalletId" required>
        <mat-option *ngFor="let wallet of wallets" [value]="wallet.id">{{wallet.walletNumber}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div>
    <mat-form-field class="full-width">
      <input matInput placeholder="Amount" [(ngModel)]="amount" appTwoDigitDecimaNumber required/>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field class="full-width">
      <input matInput placeholder="Description" [(ngModel)]="description" required/>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="basic">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" color="primary" [disabled]="!description || amount < 0.01 || !destinationWalletId">Transfer</button>
</div>

